import { createGlobalState } from '@vueuse/core'
import { shallowRef } from 'vue'

const useManagePoints = createGlobalState(() => {
  const activeIndex = shallowRef(-1)

  const setActiveIndex = (index: number) => {
    activeIndex.value = index
  }

  return { activeIndex, setActiveIndex }
})

export default useManagePoints
